import { Empty } from "@/components/atoms/Empty";
import { useTranslations } from "@/hooks/common/useTranslations";

const EmptyStateApplications = () => {
  const { t } = useTranslations("common");

  return (
    <div className="flex items-center justify-center py-28">
      <Empty title={t("notFoundApps")} />
    </div>
  );
};

export default EmptyStateApplications;
